// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__wqHw_","buttons":"SendReceipts_buttons__28P_G","email":"SendReceipts_email__2Ph7P","bookApptTitle":"SendReceipts_bookApptTitle__SS_bl"};